export default __webpack_public_path__ + "static/media/kafkalogo.d7b25c54.png";